import 'stylesheets/products/_show.scss';

import '../../assets/javascripts/adUnifiedId';
import '../../assets/javascripts/components/sentry';
import '../../assets/javascripts/components/facebook';

import ujs from '@rails/ujs';
ujs.start();

import '@polydice/icook-navbar';
import '../../assets/javascripts/components/categoriesNav';
import '../../assets/javascripts/components/webviewTrack';

import '../../assets/javascripts/reactjs/products-show';
